import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { registerPlugin } from 'ngx-filepond';

import { SubscriptionPlanRoutingModule } from '@teem/subscription-plan-module/subscription-plan-routing.module';
// import { SubscriptionPlanComponent } from '@teem/shared-component/subscription-plan/subscription-plan.component';
// import { SubscriptionPlanFormComponent } from '@teem/shared-component/subscription-plan/forms/subscription-plan-form/subscription-plan-form.component';
// import { ApplePayComponent } from '@teem/shared-component/subscription-plan/apple-pay/apple-pay.component';
// Import filepond plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';


registerPlugin(
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);

@NgModule({
  declarations: [
    // SubscriptionPlanComponent,
    // SubscriptionPlanFormComponent,
    // ApplePayComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SubscriptionPlanRoutingModule
  ]
})
export class SubscriptionPlanModule { }
